import React, { useMemo } from 'react';
import AR6ScenarioChart from '../../Charts/AR6ScenarioChart';

/**
 * Demand and Fuel Price Evolution tab (AR6 scenario drivers).
 * Accepts the same country object shape as CountryDashboard / ExistingStockTab.
 */
const DemandFuelPriceTab = ({ country }) => {
  const AR6ScenarioChartComponent = useMemo(() => {
    return (
      <AR6ScenarioChart
        countryIso={country.iso_code?.toUpperCase()}
        countryName={country.name}
      />
    );
  }, [country]);

  if (!country) {
    return null;
  }

  return (
    <div className="w-full min-w-0 overflow-x-hidden px-2 md:px-4 lg:px-6 py-2 md:py-4 lg:py-6">
      {AR6ScenarioChartComponent}
    </div>
  );
};

export default DemandFuelPriceTab;
